const translations = {
  en: {
    app: {
      title: "IRAs - Iryna Romaniuk Accounting Services",
    },
    navbar: {
      brandLine1: "IRYNA ROMANIUK",
      brandLine2: "ACCOUNTING SERVICES",
      home: "Home",
      services: "Services",
      blog: "Blog",
      contact: "Contact Us",
      language: "Language",
    },
    home: {
      heroTitle: "Innovative Reliable Accurate",
      heroSubtitle:
        "We run your numbers so you have the freedom to focus on what matters-growing your business.",
      heroButton: "Get a Free Consultation",
    },
    serviceSection: {
      title: "Our Services",
      items: {
        bookkeeping: {
          title: "Bookkeeping",
          description:
            "We handle monthly detailed financial reporting, bank reconciliations, GST/HST filing, and AP/AR management with precision.",
        },
        payroll: {
          title: "Payroll",
          description:
            "Our seamless payroll services take care of employee payments, tax withholdings, CRA remittances, and year-end reporting.",
        },
        taxes: {
          title: "Taxes",
          description:
            "Reliable and accurate tax filing, ensuring full compliance with all regulations. Trust us to manage your personal income taxes with ease and efficiency.",
        },
        consulting: {
          title: "Consulting",
          description:
            "We provide expert financial consulting, helping businesses optimize cash flow, reduce costs, and implement strategic growth plans for long-term success.",
        },
      },
    },
    uniqueApproach: {
      title: "Our Unique Approach",
      people: {
        title: "People",
        quote: "\"In unity, we find strength; in collaboration, we create change.\"",
        source: "- Inspired by Aristotle's ideas on community and virtue",
      },
      process: {
        title: "Process",
        quote:
          "\"The process is the product; every step taken shapes the final outcome.\"",
        source: "- Inspired by Aristotle's ideas on the importance of means and ends",
      },
      technology: {
        title: "Technology",
        quote:
          "\"Every technological advance is an opportunity to redefine the boundaries of possibility.\"",
        source:
          "- Inspired by Kant's philosophy on human potential and the limits of knowledge",
      },
    },
    testimonials: {
      title: "What People Say",
      seeMore: "See More on Google",
    },
    contactCta: {
      heading: "Need Help?",
      subtitle: "We're ready to assist you. Reach out today!",
      button: "Contact Us",
    },
    blog: {
      pageTitle: "Blog",
      heroTitle: "Blog",
      heroSubtitle:
        "Practical accounting tips, tax updates, and business insights from our team.",
      metaDescription:
        "Read the latest accounting tips, tax updates, and business insights from Iryna Romaniuk Accounting Services.",
      readMore: "Read more",
      backToBlog: "Back to Blog",
      loading: "Loading posts...",
      noPosts: "No blog posts yet. Check back soon!",
      notConfigured: "Blog is not configured yet. Please set up Sanity.io environment variables.",
      errorLoading: "Unable to load blog posts. Please try again later.",
      postNotFound: "This blog post could not be found.",
    },
    servicesPage: {
      heroTitle: "Our Services",
      heroSubtitle:
        "We provide expert financial solutions, bookkeeping, and tax services to help your business thrive.",
      items: {
        bookkeeping: {
          title: "Bookkeeping",
          description:
            "We handle monthly financials, GST/HST reporting, and accounts payable with precision and efficiency.",
        },
        payroll: {
          title: "Payroll",
          description:
            "Efficient payroll processing and compliance to ensure employees are paid on time, every time.",
        },
        taxes: {
          title: "Taxes",
          description:
            "Expert assistance with corporate and personal tax filings, helping you maximize savings and compliance.",
        },
        consulting: {
          title: "Consulting",
          description:
            "Strategic financial advice to help businesses grow, optimize costs, and increase profitability.",
        },
      },
    },
    contactPage: {
      heading: "Get in Touch",
      subtitle: "We're here to assist you. Reach out via phone, email, or visit our office.",
    },
    contactForm: {
      title: "Contact Us",
      nameLabel: "Name",
      namePlaceholder: "Enter your name",
      phoneLabel: "Phone",
      phonePlaceholder: "Enter phone number",
      emailLabel: "Email",
      emailPlaceholder: "Enter email address",
      messageLabel: "Message",
      messagePlaceholder: "Write your message here...",
      submitButton: "Send Message",
      sendingButton: "Sending...",
      successTitle: "Message Sent!",
      successBody: "We have received your message and will respond to you soon.",
      closeButton: "Close",
      errorNotConfigured:
        "Contact form is not configured. Please set EmailJS environment variables.",
      errorSendPrefix: "Failed to send message.",
      errorTryLater: "Please try again later.",
    },
    footer: {
      description:
        "Providing expert financial guidance, bookkeeping, and tax services with a focus on precision and excellence.",
      quickLinks: "Quick Links",
      contact: "Contact Us",
      followUs: "Follow Us",
      email: "Email",
      phone: "Phone",
      rightsReserved: "All rights reserved.",
    },
    common: {
      logoAlt: "Company Logo",
      contactHeroAlt: "Contact Us",
      servicesHeroAlt: "Services",
      helpAlt: "Need Help?",
    },
  },
  uk: {
    app: {
      title: "IRAs - Бухгалтерські послуги Ірини Романюк",
    },
    navbar: {
      brandLine1: "ІРИНА РОМАНЮК",
      brandLine2: "БУХГАЛТЕРСЬКІ ПОСЛУГИ",
      home: "Головна",
      services: "Послуги",
      blog: "Блог",
      contact: "Контакти",
      language: "Мова",
    },
    home: {
      heroTitle: "Інноваційно Надійно Точно",
      heroSubtitle:
        "Ми ведемо ваші фінанси, щоб ви могли зосередитися на головному - розвитку вашого бізнесу.",
      heroButton: "Отримати безкоштовну консультацію",
    },
    serviceSection: {
      title: "Наші послуги",
      items: {
        bookkeeping: {
          title: "Бухгалтерський облік",
          description:
            "Ми ведемо щомісячну фінансову звітність, банківські звірки, подання GST/HST та управління дебіторською і кредиторською заборгованістю.",
        },
        payroll: {
          title: "Заробітна плата",
          description:
            "Наші послуги з нарахування зарплати охоплюють виплати працівникам, податкові утримання, перерахування до CRA та річну звітність.",
        },
        taxes: {
          title: "Податки",
          description:
            "Надійне та точне подання податкової звітності з повним дотриманням вимог. Допомагаємо легко й ефективно вести особисті податки.",
        },
        consulting: {
          title: "Консалтинг",
          description:
            "Надаємо професійний фінансовий консалтинг, допомагаємо оптимізувати грошовий потік, зменшити витрати та реалізувати стратегії зростання.",
        },
      },
    },
    uniqueApproach: {
      title: "Наш унікальний підхід",
      people: {
        title: "Люди",
        quote: "\"У єдності ми знаходимо силу, а в співпраці - зміни.\"",
        source: "- Натхненно ідеями Арістотеля про спільноту та чесноти",
      },
      process: {
        title: "Процес",
        quote: "\"Процес формує результат; кожен крок визначає підсумок.\"",
        source: "- Натхненно ідеями Арістотеля про засоби та мету",
      },
      technology: {
        title: "Технології",
        quote:
          "\"Кожен технологічний прорив - це можливість розширити межі можливого.\"",
        source:
          "- Натхненно філософією Канта про людський потенціал і межі знання",
      },
    },
    testimonials: {
      title: "Що кажуть клієнти",
      seeMore: "Більше відгуків у Google",
    },
    contactCta: {
      heading: "Потрібна допомога?",
      subtitle: "Ми готові допомогти. Зв'яжіться з нами вже сьогодні!",
      button: "Зв'язатися з нами",
    },
    blog: {
      pageTitle: "Блог",
      heroTitle: "Блог",
      heroSubtitle:
        "Практичні поради з бухгалтерії, податкові оновлення та бізнес-інсайти від нашої команди.",
      metaDescription:
        "Читайте останні поради з бухгалтерії, податкові оновлення та бізнес-інсайти від бухгалтерських послуг Ірини Романюк.",
      readMore: "Читати далі",
      backToBlog: "Назад до блогу",
      loading: "Завантаження статей...",
      noPosts: "Поки що немає статей. Завітайте пізніше!",
      notConfigured: "Блог ще не налаштовано. Будь ласка, налаштуйте змінні середовища Sanity.io.",
      errorLoading: "Не вдалося завантажити статті. Спробуйте пізніше.",
      postNotFound: "Цю статтю не знайдено.",
    },
    servicesPage: {
      heroTitle: "Наші послуги",
      heroSubtitle:
        "Ми надаємо професійні фінансові рішення, бухгалтерський супровід і податкові послуги для розвитку вашого бізнесу.",
      items: {
        bookkeeping: {
          title: "Бухгалтерський облік",
          description:
            "Ведемо щомісячні фінанси, звітність GST/HST та кредиторську заборгованість з точністю та ефективністю.",
        },
        payroll: {
          title: "Заробітна плата",
          description:
            "Ефективне нарахування заробітної плати й дотримання вимог, щоб працівники отримували виплати вчасно.",
        },
        taxes: {
          title: "Податки",
          description:
            "Професійна допомога з корпоративною та персональною податковою звітністю для максимальної вигоди й відповідності вимогам.",
        },
        consulting: {
          title: "Консалтинг",
          description:
            "Стратегічні фінансові поради, що допомагають бізнесу зростати, оптимізувати витрати та підвищувати прибутковість.",
        },
      },
    },
    contactPage: {
      heading: "Зв'яжіться з нами",
      subtitle:
        "Ми тут, щоб допомогти. Телефонуйте, пишіть на email або завітайте до нашого офісу.",
    },
    contactForm: {
      title: "Контакти",
      nameLabel: "Ім'я",
      namePlaceholder: "Введіть ваше ім'я",
      phoneLabel: "Телефон",
      phonePlaceholder: "Введіть номер телефону",
      emailLabel: "Email",
      emailPlaceholder: "Введіть email адресу",
      messageLabel: "Повідомлення",
      messagePlaceholder: "Напишіть ваше повідомлення...",
      submitButton: "Надіслати повідомлення",
      sendingButton: "Надсилання...",
      successTitle: "Повідомлення надіслано!",
      successBody: "Ми отримали ваше повідомлення і скоро з вами зв'яжемося.",
      closeButton: "Закрити",
      errorNotConfigured:
        "Форма контактів не налаштована. Будь ласка, встановіть змінні середовища EmailJS.",
      errorSendPrefix: "Не вдалося надіслати повідомлення.",
      errorTryLater: "Спробуйте ще раз пізніше.",
    },
    footer: {
      description:
        "Надаємо професійний фінансовий супровід, бухгалтерський облік і податкові послуги з фокусом на точність та якість.",
      quickLinks: "Швидкі посилання",
      contact: "Контакти",
      followUs: "Слідкуйте за нами",
      email: "Email",
      phone: "Телефон",
      rightsReserved: "Усі права захищені.",
    },
    common: {
      logoAlt: "Логотип компанії",
      contactHeroAlt: "Контакти",
      servicesHeroAlt: "Послуги",
      helpAlt: "Потрібна допомога?",
    },
  },
};

export default translations;
